function initAllScripts() {

  /*
    █░░ █▀█ █▀▀ █▀█
    █▄▄ █▄█ █▄█ █▄█
    */
  var animated_ele = document.querySelector(".l_animated");
  var transitionLogo = document.querySelector(".transitionlogo");
  var animation = null;


  function isInViewport(element, offset) {
    var rect = element.getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.top >= -offset && rect.bottom <= windowHeight + offset;
  }
  function initializeAnimation() {
    if (animated_ele && transitionLogo) {
      animation = gsap.to(animated_ele, {
        duration: 1,
        paused: true,
        keyframes: [
          {
            attr: {
              d: "M1004.78 614.749C1013.5 615.68 1024.59 622.331 1027 631C1029.5 640 1018.93 647.211 1002.5 657.5C984.93 668.502 911.966 667 875.5 734C839.034 801 911.5 929 1035 832C1115.5 768.773 1120 719 1121 691C1121.27 683.484 1124.06 675.465 1127.17 666.506C1135.67 642.086 1146.59 610.688 1115.5 563.5C1086.82 519.974 1004.42 534.58 949.025 553.121C928.713 558.138 908.363 562.866 887.534 564.63C875.821 565.636 860.382 562.895 858.541 551.44C857.513 545.016 861.86 538.721 867.449 535.273C872.432 532.187 878.274 530.851 884.051 529.53C884.728 529.375 885.404 529.221 886.078 529.063C935.369 517.629 986.267 488.936 1008.9 442.428C1019.86 419.927 1020.51 394.883 1021.16 369.969C1021.89 341.657 1022.63 313.512 1038.47 289.457C1050.51 271.173 1069.58 261.226 1088.54 251.331C1108.34 241.005 1128.02 230.736 1139.5 211.108C1149.58 193.871 1147.8 168.304 1130.61 157.876C1117.93 150.168 1101.51 152.823 1087.36 157.448C1017.94 180.188 977.124 238.516 962.499 306.865C958.891 323.737 956.348 340.821 953.806 357.899C950.254 381.763 946.704 405.613 940.251 428.853C934.106 450.95 924.92 473.005 908.261 488.958C871.62 524.056 826.624 517.394 781.515 510.715C758.348 507.285 735.152 503.85 713.043 506.066C690.795 508.293 660.56 521.655 658.291 547.114C655.378 579.854 674.671 608.954 702.208 614.842C726.348 620.007 758.758 615.561 788.506 611.48C803.405 609.436 817.637 607.484 829.827 606.877C868.485 604.939 907.075 607.672 945.637 610.403C959.49 611.384 973.34 612.365 987.188 613.129C991.896 613.388 997.912 614.015 1004.78 614.749Z",
            },
          },
          {
            attr: {
              d: "M1007.5 613.5C1017 615.5 1026 622.414 1026 635.5C1026 651.5 987.688 686.573 908.761 713.5C813.5 746 488 801.546 488 1002.5C488 1139.5 706.827 1262 830.327 1165C954.306 1043.5 1072 1150.5 1160.5 1026.5C1197.1 975.224 1090.5 906.5 1099.5 753.5C1116 658.5 1147.09 608.688 1116 561.5C1087.32 517.974 1004.92 532.58 949.525 551.121C929.213 556.138 908.863 560.866 888.034 562.63C876.321 563.636 860.882 560.895 859.041 549.44C858.013 543.016 862.36 536.721 867.949 533.273C872.932 530.187 878.773 528.851 884.551 527.53C885.228 527.375 885.904 527.221 886.577 527.063C935.869 515.629 986.767 486.936 1009.4 440.428C1020.35 417.927 1021.01 392.883 1021.66 367.969C1022.39 339.657 1023.13 311.512 1038.97 287.457C1051.01 269.173 1070.08 259.226 1089.04 249.331C1108.84 239.005 1128.52 228.736 1140 209.108C1150.08 191.871 1148.3 166.304 1131.11 155.876C1118.43 148.168 1102.01 150.823 1087.86 155.448C1018.44 178.188 977.624 236.516 962.999 304.865C959.391 321.737 956.848 338.821 954.306 355.899C950.754 379.763 947.204 403.613 940.751 426.853C934.606 448.95 925.42 471.005 908.761 486.958C872.12 522.056 827.124 515.394 782.015 508.715C758.848 505.285 735.652 501.85 713.542 504.066C691.295 506.293 661.06 519.655 658.79 545.114C655.878 577.854 675.171 606.954 702.708 612.842C726.848 618.007 759.258 613.561 789.006 609.48C803.905 607.436 818.136 605.484 830.327 604.877C868.985 602.939 907.574 605.672 946.137 608.403C959.99 609.384 973.84 610.365 987.688 611.129C992.396 611.388 1000.74 612.077 1007.5 613.5Z",
            },
          },
          {
            attr: {
              d: "M1008.5 617C1020.5 621.709 1029.5 639.5 1021.5 656C1013.5 672.5 900.792 787.323 658.675 814.5C284.5 856.5 74.5 1050.05 74.5 1251C74.5 1388 477.5 1363 815.5 1307C1079 1252 1407 1272.84 1407 1120.5C1407 1031.5 1090.38 907.5 1099.38 754.5C1115.88 659.5 1146.98 609.688 1115.88 562.5C1087.2 518.974 1004.8 533.58 949.41 552.121C929.097 557.138 908.748 561.866 887.918 563.63C876.205 564.636 860.767 561.895 858.925 550.44C857.897 544.016 862.244 537.721 867.833 534.273C872.816 531.187 878.658 529.851 884.436 528.53C885.112 528.375 885.788 528.221 886.462 528.063C935.754 516.629 986.651 487.936 1009.28 441.428C1020.24 418.927 1020.89 393.883 1021.54 368.969C1022.28 340.657 1023.01 312.512 1038.86 288.457C1050.89 270.173 1069.96 260.226 1088.93 250.331C1108.72 240.005 1128.41 229.736 1139.88 210.108C1149.97 192.871 1148.19 167.304 1130.99 156.876C1118.32 149.168 1101.89 151.823 1087.74 156.448C1018.32 179.188 977.508 237.516 962.883 305.865C959.275 322.737 956.732 339.821 954.19 356.899C950.638 380.763 947.088 404.613 940.636 427.853C934.49 449.95 925.304 472.005 908.645 487.958C872.005 523.056 827.008 516.394 781.899 509.715C758.732 506.285 735.536 502.85 713.427 505.066C691.179 507.293 660.944 520.655 658.675 546.114C655.763 578.854 675.055 607.954 702.592 613.842C726.732 619.007 759.142 614.561 788.89 610.48C803.789 608.436 818.021 606.484 830.211 605.877C868.87 603.939 907.459 606.672 946.021 609.403C959.874 610.384 973.724 611.365 987.572 612.129C992.28 612.388 1002.07 614.476 1008.5 617Z",
            },
          },
          {
            attr: {
              d: "M1008.5 617C1020.5 621.709 1029.5 639.5 1021.5 656C1013.5 672.5 900.792 787.323 658.674 814.5C284.5 856.5 137 988 74.4999 1251C12.0002 1514 446.282 1464.5 788.89 1464.5C1087.74 1464.5 1592.5 1511 1432.5 1165C1311.66 903.69 1090.38 907.5 1099.38 754.5C1115.88 659.5 1146.98 609.688 1115.88 562.5C1087.2 518.974 1004.8 533.58 949.409 552.121C929.097 557.138 908.747 561.866 887.917 563.63C876.205 564.636 860.766 561.895 858.925 550.44C857.897 544.016 862.244 537.721 867.832 534.273C872.816 531.187 878.657 529.851 884.435 528.53C885.112 528.375 885.788 528.221 886.461 528.063C935.753 516.629 986.651 487.936 1009.28 441.428C1020.24 418.927 1020.89 393.883 1021.54 368.969C1022.28 340.657 1023.01 312.512 1038.85 288.457C1050.89 270.173 1069.96 260.226 1088.93 250.331C1108.72 240.005 1128.41 229.736 1139.88 210.108C1149.96 192.871 1148.19 167.304 1130.99 156.876C1118.32 149.168 1101.89 151.823 1087.74 156.448C1018.32 179.188 977.508 237.516 962.883 305.865C959.275 322.737 956.732 339.821 954.19 356.899C950.638 380.763 947.088 404.613 940.635 427.853C934.49 449.95 925.304 472.005 908.645 487.958C872.004 523.056 827.008 516.394 781.899 509.715C758.732 506.285 735.536 502.85 713.426 505.066C691.179 507.293 660.944 520.655 658.674 546.114C655.762 578.854 675.055 607.954 702.592 613.842C726.732 619.007 759.142 614.561 788.89 610.48C803.789 608.436 818.02 606.484 830.211 605.877C868.869 603.939 907.458 606.672 946.021 609.403C959.874 610.384 973.724 611.365 987.572 612.129C992.28 612.388 1002.07 614.476 1008.5 617Z",
            },
          },
        ],
        onUpdate: function () {
          //console.log(animation);
        },
      });
    }
  }


  function handleScrollTrans() {
    if (animated_ele && transitionLogo) {
      var offset = window.innerHeight * 0.5;
      if (isInViewport(transitionLogo, offset)) {
        var rect = transitionLogo.getBoundingClientRect();
        var windowHeight =
          window.innerHeight || document.documentElement.clientHeight;
        var scrollHeight = transitionLogo.offsetHeight - windowHeight;
        var scrollPercent = 25 + ((rect.top / scrollHeight) * 100 + 100);

        if (!animation) {
          animation = gsap.to(animated_ele, {
            duration: 1,
            paused: true,
            keyframes: [
              {
                attr: {
                  d: "M1004.78 614.749C1013.5 615.68 1024.59 622.331 1027 631C1029.5 640 1018.93 647.211 1002.5 657.5C984.93 668.502 911.966 667 875.5 734C839.034 801 911.5 929 1035 832C1115.5 768.773 1120 719 1121 691C1121.27 683.484 1124.06 675.465 1127.17 666.506C1135.67 642.086 1146.59 610.688 1115.5 563.5C1086.82 519.974 1004.42 534.58 949.025 553.121C928.713 558.138 908.363 562.866 887.534 564.63C875.821 565.636 860.382 562.895 858.541 551.44C857.513 545.016 861.86 538.721 867.449 535.273C872.432 532.187 878.274 530.851 884.051 529.53C884.728 529.375 885.404 529.221 886.078 529.063C935.369 517.629 986.267 488.936 1008.9 442.428C1019.86 419.927 1020.51 394.883 1021.16 369.969C1021.89 341.657 1022.63 313.512 1038.47 289.457C1050.51 271.173 1069.58 261.226 1088.54 251.331C1108.34 241.005 1128.02 230.736 1139.5 211.108C1149.58 193.871 1147.8 168.304 1130.61 157.876C1117.93 150.168 1101.51 152.823 1087.36 157.448C1017.94 180.188 977.124 238.516 962.499 306.865C958.891 323.737 956.348 340.821 953.806 357.899C950.254 381.763 946.704 405.613 940.251 428.853C934.106 450.95 924.92 473.005 908.261 488.958C871.62 524.056 826.624 517.394 781.515 510.715C758.348 507.285 735.152 503.85 713.043 506.066C690.795 508.293 660.56 521.655 658.291 547.114C655.378 579.854 674.671 608.954 702.208 614.842C726.348 620.007 758.758 615.561 788.506 611.48C803.405 609.436 817.637 607.484 829.827 606.877C868.485 604.939 907.075 607.672 945.637 610.403C959.49 611.384 973.34 612.365 987.188 613.129C991.896 613.388 997.912 614.015 1004.78 614.749Z",
                },
              },
              {
                attr: {
                  d: "M1007.5 613.5C1017 615.5 1026 622.414 1026 635.5C1026 651.5 987.688 686.573 908.761 713.5C813.5 746 488 801.546 488 1002.5C488 1139.5 706.827 1262 830.327 1165C954.306 1043.5 1072 1150.5 1160.5 1026.5C1197.1 975.224 1090.5 906.5 1099.5 753.5C1116 658.5 1147.09 608.688 1116 561.5C1087.32 517.974 1004.92 532.58 949.525 551.121C929.213 556.138 908.863 560.866 888.034 562.63C876.321 563.636 860.882 560.895 859.041 549.44C858.013 543.016 862.36 536.721 867.949 533.273C872.932 530.187 878.773 528.851 884.551 527.53C885.228 527.375 885.904 527.221 886.577 527.063C935.869 515.629 986.767 486.936 1009.4 440.428C1020.35 417.927 1021.01 392.883 1021.66 367.969C1022.39 339.657 1023.13 311.512 1038.97 287.457C1051.01 269.173 1070.08 259.226 1089.04 249.331C1108.84 239.005 1128.52 228.736 1140 209.108C1150.08 191.871 1148.3 166.304 1131.11 155.876C1118.43 148.168 1102.01 150.823 1087.86 155.448C1018.44 178.188 977.624 236.516 962.999 304.865C959.391 321.737 956.848 338.821 954.306 355.899C950.754 379.763 947.204 403.613 940.751 426.853C934.606 448.95 925.42 471.005 908.761 486.958C872.12 522.056 827.124 515.394 782.015 508.715C758.848 505.285 735.652 501.85 713.542 504.066C691.295 506.293 661.06 519.655 658.79 545.114C655.878 577.854 675.171 606.954 702.708 612.842C726.848 618.007 759.258 613.561 789.006 609.48C803.905 607.436 818.136 605.484 830.327 604.877C868.985 602.939 907.574 605.672 946.137 608.403C959.99 609.384 973.84 610.365 987.688 611.129C992.396 611.388 1000.74 612.077 1007.5 613.5Z",
                },
              },
              {
                attr: {
                  d: "M1008.5 617C1020.5 621.709 1029.5 639.5 1021.5 656C1013.5 672.5 900.792 787.323 658.675 814.5C284.5 856.5 74.5 1050.05 74.5 1251C74.5 1388 477.5 1363 815.5 1307C1079 1252 1407 1272.84 1407 1120.5C1407 1031.5 1090.38 907.5 1099.38 754.5C1115.88 659.5 1146.98 609.688 1115.88 562.5C1087.2 518.974 1004.8 533.58 949.41 552.121C929.097 557.138 908.748 561.866 887.918 563.63C876.205 564.636 860.767 561.895 858.925 550.44C857.897 544.016 862.244 537.721 867.833 534.273C872.816 531.187 878.658 529.851 884.436 528.53C885.112 528.375 885.788 528.221 886.462 528.063C935.754 516.629 986.651 487.936 1009.28 441.428C1020.24 418.927 1020.89 393.883 1021.54 368.969C1022.28 340.657 1023.01 312.512 1038.86 288.457C1050.89 270.173 1069.96 260.226 1088.93 250.331C1108.72 240.005 1128.41 229.736 1139.88 210.108C1149.97 192.871 1148.19 167.304 1130.99 156.876C1118.32 149.168 1101.89 151.823 1087.74 156.448C1018.32 179.188 977.508 237.516 962.883 305.865C959.275 322.737 956.732 339.821 954.19 356.899C950.638 380.763 947.088 404.613 940.636 427.853C934.49 449.95 925.304 472.005 908.645 487.958C872.005 523.056 827.008 516.394 781.899 509.715C758.732 506.285 735.536 502.85 713.427 505.066C691.179 507.293 660.944 520.655 658.675 546.114C655.763 578.854 675.055 607.954 702.592 613.842C726.732 619.007 759.142 614.561 788.89 610.48C803.789 608.436 818.021 606.484 830.211 605.877C868.87 603.939 907.459 606.672 946.021 609.403C959.874 610.384 973.724 611.365 987.572 612.129C992.28 612.388 1002.07 614.476 1008.5 617Z",
                },
              },
              {
                attr: {
                  d: "M1008.5 617C1020.5 621.709 1029.5 639.5 1021.5 656C1013.5 672.5 900.792 787.323 658.674 814.5C284.5 856.5 137 988 74.4999 1251C12.0002 1514 446.282 1464.5 788.89 1464.5C1087.74 1464.5 1592.5 1511 1432.5 1165C1311.66 903.69 1090.38 907.5 1099.38 754.5C1115.88 659.5 1146.98 609.688 1115.88 562.5C1087.2 518.974 1004.8 533.58 949.409 552.121C929.097 557.138 908.747 561.866 887.917 563.63C876.205 564.636 860.766 561.895 858.925 550.44C857.897 544.016 862.244 537.721 867.832 534.273C872.816 531.187 878.657 529.851 884.435 528.53C885.112 528.375 885.788 528.221 886.461 528.063C935.753 516.629 986.651 487.936 1009.28 441.428C1020.24 418.927 1020.89 393.883 1021.54 368.969C1022.28 340.657 1023.01 312.512 1038.85 288.457C1050.89 270.173 1069.96 260.226 1088.93 250.331C1108.72 240.005 1128.41 229.736 1139.88 210.108C1149.96 192.871 1148.19 167.304 1130.99 156.876C1118.32 149.168 1101.89 151.823 1087.74 156.448C1018.32 179.188 977.508 237.516 962.883 305.865C959.275 322.737 956.732 339.821 954.19 356.899C950.638 380.763 947.088 404.613 940.635 427.853C934.49 449.95 925.304 472.005 908.645 487.958C872.004 523.056 827.008 516.394 781.899 509.715C758.732 506.285 735.536 502.85 713.426 505.066C691.179 507.293 660.944 520.655 658.674 546.114C655.762 578.854 675.055 607.954 702.592 613.842C726.732 619.007 759.142 614.561 788.89 610.48C803.789 608.436 818.02 606.484 830.211 605.877C868.869 603.939 907.458 606.672 946.021 609.403C959.874 610.384 973.724 611.365 987.572 612.129C992.28 612.388 1002.07 614.476 1008.5 617Z",
                },
              },
            ],
            onUpdate: function () {
              //console.log(animation);
            },
          });
        }
        var progress = scrollPercent / 100;
        animation.progress(progress);
      } else {
        if (animation) {
          animation.progress(100).pause();
        }
      }
    }
  }
  document.addEventListener("DOMContentLoaded", initializeAnimation);

  // Handle scroll event
  window.addEventListener("scroll", handleScrollTrans);



  /*
    █▀█ █▀█ █▀█ █▀▄ █░█ █▀▀ ▀█▀ █▀
    █▀▀ █▀▄ █▄█ █▄▀ █▄█ █▄▄ ░█░ ▄█
    */

  const sliders = document.querySelectorAll(".product__slider");

  sliders.forEach((slider) => {
    const wrapper = slider.querySelector(".slider__wrapper");
    const prevBtn = slider.querySelector(".slider__prev");
    const nextBtn = slider.querySelector(".slider__next");
    const items = slider.querySelectorAll(".slider__item");
    let itemWidth, visibleItemCount, currentIndex, totalItemCount;

    updateSliderDimensions();

    if (items.length <= visibleItemCount) {
      if (prevBtn) {
        prevBtn.style.display = "none";
      }
      if (nextBtn) {
        nextBtn.style.display = "none";
      }
      return;
    }

    function slideToIndex(index) {
      currentIndex = index;
      const transformValue = -itemWidth * currentIndex;
      wrapper.style.transform = `translateX(${transformValue}px)`;
    }

    function updateSliderDimensions() {
      itemWidth = items[0].offsetWidth;
      visibleItemCount = Math.floor(slider.offsetWidth / itemWidth);
      totalItemCount = items.length;
      slideToIndex(currentIndex || 0);
    }

    window.addEventListener("resize", updateSliderDimensions);

    prevBtn.addEventListener("click", () => {
      currentIndex =
        currentIndex === 0
          ? totalItemCount - visibleItemCount
          : currentIndex - 1;
      slideToIndex(currentIndex);
    });

    nextBtn.addEventListener("click", () => {
      currentIndex =
        currentIndex === totalItemCount - visibleItemCount
          ? 0
          : currentIndex + 1;
      slideToIndex(currentIndex);
    });
  });
  const gridItems = document.querySelectorAll(".grid__item_shopgrid");
  /*
    const quickViewButtons = document.querySelectorAll(".quick-view-button");
    const modals = document.querySelectorAll(".modal_quickview");
    quickViewButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const closestModal = button
          .closest(".grid__item_shopgrid")
          .querySelector(".modal_quickview");
  
        modals.forEach((modal) => {
          modal.classList.remove("active");
        });
        closestModal.classList.add("active");
        const modalCloseButton = closestModal.querySelector(".close");
        function closeModal() {
          closestModal.classList.remove("active");
        }
        modalCloseButton.addEventListener("click", closeModal);
        closestModal.addEventListener("click", (e) => {
          if (e.target.classList.contains("modal_quickview")) {
            closeModal();
          }
        });
        document.addEventListener("keyup", (e) => {
          if (e.keyCode === 27) {
            closeModal();
          }
        });
      });
    });
  */
  gridItems.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      item.classList.add("hovered");
    });

    item.addEventListener("mouseleave", () => {
      item.classList.remove("hovered");
    });
  });

  /*
    █▀ █░░ █ █▀▄ █▀▀ █▀█
    ▄█ █▄▄ █ █▄▀ ██▄ █▀▄
    */
  const slider = document.getElementById("slider");
  if (slider) {
    slider.addEventListener("mousedown", handleMouseDown);
  }
  function handleMouseDown(e) {
    e.preventDefault();
    slider.style.cursor = "grabbing";
    const startX = e.pageX - slider.offsetLeft;
    const scrollLeft = slider.scrollLeft;
    let startMoving = true;
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
    function onMouseMove(e) {
      if (!startMoving) return;
      const x = e.pageX - slider.offsetLeft;
      const move = x - startX;
      slider.scrollLeft = scrollLeft - move;
    }
    function onMouseUp() {
      startMoving = false;
      slider.style.cursor = "ew-resize";
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    }
  }
  /*
    █▀▄▀█ █▀▀ █▄░█ █░█
    █░▀░█ ██▄ █░▀█ █▄█
    */
  const menuDrawer = document.querySelector("#menu-drawer");
  const spanMenu = document.querySelector(".menuclick span");
  const cartcolor = document.querySelector(".cart-icon-bubble");
  const relative_menu_100 = document.querySelector(".relative_menu_100");

  function toggleMenu() {
    if (menuDrawer.classList.contains("menu-drawer--visible")) {
      cartcolor.classList.remove("transparent");
      menuDrawer.classList.toggle("menu-drawer--visible");

      menuDrawer.classList.toggle("menu-drawer--hidden");
      spanMenu.innerHTML = "MENU";
      relative_menu_100.classList.toggle("visible");
    } else {
      cartcolor.classList.add("transparent");
      menuDrawer.classList.toggle("menu-drawer--hidden");
      menuDrawer.classList.toggle("menu-drawer--visible");
      spanMenu.innerHTML = 'CLOSE';
      relative_menu_100.classList.toggle("visible");
    }
  }
  const menuClick = document.querySelector(".menuclick");
  if (menuClick) {
    menuClick.addEventListener("click", toggleMenu);
  }

  if (relative_menu_100) {
    var header = document.querySelector(".sticky-header");
    var headerHeight = relative_menu_100.offsetHeight;
    var headerPosition = relative_menu_100.offsetTop;

    function updateHeaderPosition() {
      headerHeight = relative_menu_100.offsetHeight;
      headerPosition = relative_menu_100.offsetTop;
    }

    function handleScroll() {
      var scrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      if (scrollPosition > headerPosition) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    }
    function throttle(func, delay) {
      let timer = null;
      return function () {
        if (!timer) {
          timer = setTimeout(() => {
            func.apply(this, arguments);
            timer = null;
          }, delay);
        }
      };
    }
    updateHeaderPosition();
    window.addEventListener("scroll", throttle(handleScroll, 100));
    window.addEventListener("resize", updateHeaderPosition);
  }

  /*
    █▀▀ █▀█ █ █▀▄
    █▄█ █▀▄ █ █▄▀
    */
  const clickGridMenu = document.querySelector(".click_grid_menu");
  const collectionGridCategories = document.querySelector(
    ".collection-grid_categories"
  );

  if (clickGridMenu) {
    clickGridMenu.addEventListener("click", function () {
      if (collectionGridCategories.classList.contains("active")) {
        collectionGridCategories.classList.remove("active");
        collectionGridCategories.classList.add("inactive");
      } else {
        collectionGridCategories.classList.remove("inactive");
        collectionGridCategories.classList.add("active");
      }
    });
  }

  /*
█▀ █▀▀ █▀█ █▀█ █░░ █░░   ▄▀█ █▄░█ █ █▀▄▀█
▄█ █▄▄ █▀▄ █▄█ █▄▄ █▄▄   █▀█ █░▀█ █ █░▀░█
*/
  Splitting();

  function scrollTriggerElements(elements, offset) {
    var windowHeight =
      window.innerHeight || document.documentElement.clientHeight;

    elements.forEach(function (element) {
      var rect = element.getBoundingClientRect();
      var triggerPoint = windowHeight - offset;
      var inTriggerPoint = rect.top <= triggerPoint;

      element.inTriggerPoint = inTriggerPoint;
    });
  }

  var enterElements = document.querySelectorAll(".scroll-enter");
  var unfoldElements = document.querySelectorAll(".scroll-unfold");
  var ghostElements = document.querySelectorAll(".scroll-ghost");
  var dropElements = document.querySelectorAll(".scroll-drop"); // New drop elements
  var offset = 150;

  var enterTimelines = [],
    unfoldTimelines = [],
    ghostTimelines = [],
    dropTimelines = []; // New drop timelines

  // ENTER ANIMATION
  if (enterElements.length > 0) {
    enterElements.forEach(function (element) {
      var enterTimeline = gsap.timeline({
        paused: true,
        defaults: { duration: 1, ease: "power3.out" },
      });

      enterTimeline.fromTo(
        element,
        {
          opacity: 0,
          rotationX: 45,
          y: 25,
        },
        {
          opacity: 1,
          rotationX: 0,
          y: 0,
        }
      );

      enterTimelines.push(enterTimeline);
    });
  }

  // UNFOLD ANIMATION
  if (unfoldElements.length > 0) {
    unfoldElements.forEach(function (element) {
      var chars = element.querySelectorAll(".char");
      var delayScroll = element.attributes["scroll-delay"]
        ? element.attributes["scroll-delay"].value
        : 0;

      chars.forEach(function (char) {
        gsap.set(char.parentNode, { perspective: 2000 });
      });

      var unfoldTimeline = gsap.timeline({
        paused: true,
        defaults: { duration: 1, ease: "power3.out", delay: delayScroll },
      });

      unfoldTimeline.fromTo(
        chars,
        {
          "will-change": "opacity, transform",
          transformOrigin: "center center",
          opacity: 0,
          rotationY: -45,
          y: 50,
        },
        {
          ease: "expo",
          opacity: 1,
          rotationY: 0,
          y: 0,
          stagger: { each: 0.05, from: "end" },
        }
      );

      unfoldTimelines.push(unfoldTimeline);
    });
  }

  // GHOST ANIMATION 
  if (ghostElements && ghostElements.length > 0) {
    ghostElements.forEach(element => {
      const chars = element.querySelectorAll(".char");
      if (!chars || chars.length === 0) return;
      let delayScroll = 0;
      if (element.hasAttribute("scroll-delay")) {
        delayScroll = parseFloat(element.getAttribute("scroll-delay")) || 0;
      }
      gsap.set(Array.from(chars).map(char => char.parentNode), { perspective: 2000 });

      const ghostTimeline = gsap.timeline({
        paused: true,
        defaults: {
          duration: 1,
          ease: "power3.out",
          delay: delayScroll
        }
      });

      ghostTimeline.fromTo(
        chars,
        {
          "will-change": "opacity, transform",
          transformOrigin: "center center",
          opacity: 0.25,
          rotationX: -5,
        },
        {
          ease: "expo",
          opacity: 1,
          rotationX: 0,
          stagger: { each: 0.005, from: "start" },
        }
      );
      ghostTimelines.push(ghostTimeline);
    });
  }


  // DROP ANIMATION
  if (dropElements.length > 0) {
    dropElements.forEach(function (element) {
      var chars = element.querySelectorAll(".char");
      var delayScroll = element.attributes["scroll-delay"]
        ? element.attributes["scroll-delay"].value
        : 0;

      chars.forEach(function (char) {
        gsap.set(char.parentNode, { perspective: 2000 });
      });

      var dropTimeline = gsap.timeline({
        paused: true,
        defaults: { duration: 1, ease: "power3.out", delay: delayScroll },
      });

      dropTimeline.fromTo(
        chars,
        {
          "will-change": "opacity, transform",
          transformOrigin: "center center",
          opacity: 0,
          transform: "translateZ(-100px)",
          rotationX: 45,
        },
        {
          ease: "expo",
          opacity: 1,
          transform: "translateZ(0px)",
          rotationX: 0,
          stagger: { each: 0.04, from: "start" },
        }
      );

      dropTimelines.push(dropTimeline);
    });
  }

  function checkElementsVisibility() {
    if (unfoldElements.length > 0) {
      scrollTriggerElements(unfoldElements, offset);

      unfoldElements.forEach(function (element, index) {
        if (element.inTriggerPoint) {
          unfoldTimelines[index].play();
        } else {
          unfoldTimelines[index].reverse();
        }
      });
    }

    if (enterElements.length > 0) {
      scrollTriggerElements(enterElements, offset);

      enterElements.forEach(function (element, index) {
        if (element.inTriggerPoint) {
          enterTimelines[index].play();
        } else {
          enterTimelines[index].reverse();
        }
      });
    }

    if (ghostElements.length > 0) {
      scrollTriggerElements(ghostElements, offset);

      ghostElements.forEach(function (element, index) {
        if (element.inTriggerPoint) {
          ghostTimelines[index].play();
        } else {
          ghostTimelines[index].reverse();
        }
      });
    }

    if (dropElements.length > 0) {
      scrollTriggerElements(dropElements, offset);

      dropElements.forEach(function (element, index) {
        if (element.inTriggerPoint) {
          dropTimelines[index].play();
        } else {
          dropTimelines[index].reverse();
        }
      });
    }
  }

  checkElementsVisibility();

  window.addEventListener("scroll", function () {
    checkElementsVisibility();
  });
}
/*
function pageTransition() {
  const pageTransitionElement = document.querySelector('.page-transition');
  pageTransitionElement.classList.add('is-animating');
  setTimeout(() => {
    pageTransitionElement.classList.remove('is-animating');
    window.scrollTo(0, 0);
  }, 1000);
}*/

document.addEventListener("DOMContentLoaded", function () {
  initAllScripts();
});    